const carColumns = [
  {
    label: 'Vehicle VIN',
    value: 'chassisNumber',
    textId: 'fleetadmin.car.table.vin',
    disabled: true,
  },
  {
    label: 'Status',
    value: 'status',
    textId: 'fleetadmin.car.table.status',
    disabled: false,
  },
  {
    label: 'Location',
    value: 'position',
    textId: 'fleetadmin.car.table.location',
    disabled: false,
  },
  {
    label: 'AccessKit type',
    value: 'vehicleConnection',
    textId: 'fleetadmin.car.table.accesskittype',
    disabled: false,
  },
  {
    label: 'LastStatusChange',
    value: 'statusChangedAt',
    textId: 'fleetadmin.car.table.laststatuschange',
    disabled: false,
  },
  {
    label: 'Equipped',
    value: 'equippedSince',
    textId: 'fleetadmin.car.table.equipped',
    disabled: false,
  },
  {
    label: 'First ReleasedReady',
    value: 'firstReleaseReadyAt',
    textId: 'fleetadmin.car.table.firstreleaseready',
    disabled: false,
  },
  {
    label: 'Plate',
    value: 'plate',
    textId: 'fleetadmin.car.table.plate',
    disabled: false,
  },
  {
    label: 'Model',
    value: 'model',
    textId: 'fleetadmin.car.table.model',
    disabled: false,
  },
  {
    label: 'Fleet',
    value: 'fleetId',
    textId: 'fleetadmin.car.table.fleet',
    disabled: false,
  },
  {
    label: 'Area',
    value: 'areaId',
    textId: 'fleetadmin.car.table.area',
    disabled: false,
  },
  {
    label: 'Battery voltage',
    value: 'lastStatus.batteryVoltage',
    textId: 'fleetadmin.car.table.batteryvoltage',
    disabled: false,
  },
  {
    label: 'Cloudbox status',
    value: 'lastStatus.online',
    textId: 'fleetadmin.car.table.cloudboxstatus',
    disabled: false,
  },
  {
    label: 'Fuel status',
    value: 'lastStatus.fuelLevel',
    textId: 'fleetadmin.car.table.fuelstatus',
    disabled: false,
  },
  {
    label: 'Key Type',
    value: 'keyFobRequired',
    textId: 'fleetadmin.car.table.keytype',
    disabled: false,
  },
  {
    label: 'Key',
    value: 'lastStatus.keyFobIn',
    textId: 'fleetadmin.car.table.key',
    disabled: false,
  },
  {
    label: 'FuelCard',
    value: 'lastStatus.fuelCardIn',
    textId: 'fleetadmin.car.table.fuelcard',
    disabled: false,
  },
  {
    label: 'Action',
    value: 'operation',
    textId: 'fleetadmin.car.table.action',
    disabled: false,
  },
];

export const defaultSelectedCarColumns = carColumns
  .map((carColumn) => carColumn.value)
  .filter((carColumn) => !carColumn.startsWith('lastStatus'));

export default carColumns;
